import React, { Component } from 'react';
import elEjecutivo from '../../assets/svg/IllustracionEjecutivoBig.svg'
import './ejecutivo.css';

class Ejecutivo extends Component {

  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {
    const { mensaje, mensajesEnrriqusidos, tipo } = this.props;
    const mensajesEnrriqusidosFormato = mensajesEnrriqusidos ? (mensajesEnrriqusidos.map((item) => (
      <div key={item.mensaje}>
        {item.tipo === 'strong' ? (
          <strong>
            {item.mensaje}
          </strong>
        ) : item.mensaje}
      </div>
    ))) : null;

    return (
      <div className="ejecutivo">
        {tipo === "top" && (
          <>
            <div className="triangle"><div /></div>
            <img src={elEjecutivo} className="iconModal" alt="svg" />
            <span>
              {mensaje && mensaje}
              {mensajesEnrriqusidos && mensajesEnrriqusidosFormato}
            </span>
          </>
        )}
        {tipo === "right" && (
          <>
            <div className="triangleRight"><div /></div>
            <img src={elEjecutivo} className="iconModalRight" alt="svg" />
            <div className={tipo}>
              {mensaje && mensaje}
              {mensajesEnrriqusidos && mensajesEnrriqusidosFormato}
            </div>
          </>
        )}


      </div>
    )
  };
};

export default Ejecutivo;
